import type { MegaColumn, MegaItem, NavLink } from "./types";
import { HELP_URL, DEVELOPERS_URL, ROUTES } from "@/lib/constants";

export function megaLinkProps(item: MegaItem) {
  return item.external ? { target: "_blank" as const, rel: "noopener noreferrer" as const } : {};
}

const productsMega: MegaColumn[] = [
  {
    items: [
      { category: "Mobile", label: "Mobile Proxies", href: "/proxy-server/mobile-proxies" },
      {
        category: "Residential",
        label: "Residential Proxies",
        href: "/proxy-server/residential-proxies",
      },
    ],
  },
];

const pricingMega: MegaColumn[] = [
  {
    items: [
      { category: "Mobile", label: "Mobile Proxies", href: "/mobile-proxy-pricing" },
      {
        category: "Residential",
        label: "Residential Proxies",
        href: "/residential-proxies-pricing",
      },
    ],
  },
];

const resourcesMega: MegaColumn[] = [
  {
    items: [
      { category: "Explore", label: "Use Cases", href: "/use-cases" },
      { category: "Explore", label: "Alternatives", href: "/alternatives" },
      { category: "Explore", label: "Research", href: "/research" },
      { category: "Explore", label: "Blog", href: "/blog" },
    ],
  },
  {
    items: [
      { category: "Explore", label: "Proxy Server", href: "/proxy-server" },
      { category: "Connect", label: "Partners", href: "/partners" },
      { category: "Support", label: "Help Center", href: HELP_URL, external: true },
    ],
  },
];

const companyMega: MegaColumn[] = [
  {
    items: [
      { category: "Company", label: "About", href: "/about" },
      { category: "Company", label: "Enterprise", href: "/enterprise" },
      { category: "Company", label: "Careers", href: "/careers" },
      { category: "Company", label: "Contact", href: "/contact" },
    ],
  },
  {
    items: [
      { category: "More", label: "Ethics", href: "/ethics" },
      { category: "More", label: "Legal", href: "/legal" },
      { category: "More", label: "Referral Program", href: "/referral-program" },
    ],
  },
];

const developersMega: MegaColumn[] = [
  {
    items: [
      { category: "Docs", label: "API Docs", href: DEVELOPERS_URL, external: true },
      { category: "Program", label: "MCP Server", href: "/tools/mcp-server", chip: "New" },
      { category: "Open Source", label: "Open Source Projects", href: "/open-source" },
    ],
  },
  {
    items: [
      {
        category: "Tools",
        label: "All Tools",
        href: ROUTES.tools,
      },
      {
        category: "Tools",
        label: "Chrome Extension",
        href: "/tools/chrome-extension",
      },
      {
        category: "Tools",
        label: "Firefox Extension",
        href: "/tools/firefox-extension",
      },
    ],
  },
];

export const navLinks: NavLink[] = [
  { label: "Products", href: "/proxy-server/mobile-proxies", mega: productsMega },
  { label: "Resources", href: "/research", mega: resourcesMega },
  { label: "Company", href: "/about", mega: companyMega },
  { label: "Developers", href: DEVELOPERS_URL, mega: developersMega },
  { label: "Pricing", href: "/mobile-proxy-pricing", mega: pricingMega },
];
